/*
 * Copyright (c) 2022 automata-network/tgb-donation authors and contributors.
 * This software may be modified and distributed under the terms of MIT license.
 * Refer to the LICENSE file for details.
 */
import { forwardRef } from 'react'

import { useThemeContext } from '../../contexts/ThemeContext'
import { BaseButton } from './'
import { Props as BaseButtonProps } from './BaseButton'

type Props = Omit<BaseButtonProps, 'bgColor' | 'strokeColor'>

const PrimaryButton = forwardRef<HTMLButtonElement, Props>(
  (
    {
      // Button attributes
      borderRadius,
      outlined,
      size,
      strokeWidth,
      textColor,
      textSize,
      // Element attributes
      as,
      children,
      className,
      disabled = false,
      type = 'button',
      // Event handler
      onClick,
      onKeyDown
    }: Props,
    ref
  ) => {
    const { colors } = useThemeContext()

    return (
      <BaseButton
        ref={ref}
        bgColor={colors.primary}
        borderRadius={borderRadius}
        outlined={outlined}
        size={size}
        strokeColor={outlined ? colors.primary : undefined}
        strokeWidth={outlined ? strokeWidth : 1}
        textColor={outlined ? colors.primary : textColor ?? colors.baseWhite}
        textSize={textSize}
        as={as}
        className={className}
        disabled={disabled}
        type={type}
        onClick={onClick}
        onKeyDown={onKeyDown}
      >
        {children}
      </BaseButton>
    )
  }
)

export default PrimaryButton
